module.exports = __webpack_public_path__ + "media/images/photo/Residential/slider1-412f29465a8c44981984bacedc52051c.png";